import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config';
import type {
  SetCompanyHasSecurityAddonParams,
  SetCompanyHasSecurityAddonResponse,
} from '../../../../types/security';

/**
 * 運営スタッフ専用: 企業の has_security_addon を切り替える（#2982-2985）。
 * Webhook / API 機能トグルと同じ運用パターン。
 */
interface SetCompanyHasSecurityAddonRawResponse {
  success: boolean;
  before: boolean;
  after: boolean;
}

export const setCompanyHasSecurityAddon = async (
  params: SetCompanyHasSecurityAddonParams,
): Promise<SetCompanyHasSecurityAddonResponse> => {
  const callable = httpsCallable<
    SetCompanyHasSecurityAddonParams,
    SetCompanyHasSecurityAddonRawResponse
  >(functions, 'setCompanyHasSecurityAddon');
  const result = await callable(params);
  return {
    before: result.data.before,
    after: result.data.after,
  };
};
